import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatTimestamp } from "../../../utils/utils";
import styles from "../network_map.module.css";

function ChangeRow({ item, onGo, t }) {
  const down = item.delta < 0;
  return (
    <div className={styles.changeRow}>
      <div className={`${styles.delta} ${down ? styles.deltaDown : styles.deltaUp}`}>
        {down ? "▼" : "▲"} {Math.abs(Math.round(item.delta))}
      </div>
      <div className={styles.changeMain}>
        <div className={styles.changeScores}>
          {t("netmap.changes.before")} {Math.round(item.score_before)} → {t("netmap.changes.after")} {Math.round(item.score_after)}
        </div>
        <div className={styles.changeMeta}>
          {item.lat.toFixed(5)}, {item.lon.toFixed(5)} · {t("netmap.changes.samples", { before: item.n_before, after: item.n_after })} · {formatTimestamp(item.last_seen)}
        </div>
      </div>
      <button type="button" className={styles.smallButton} onClick={() => onGo(item)}>{t("netmap.changes.go")}</button>
    </div>
  );
}

export default function ChangesPanel({ changes, error, onGo }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState("worsened");
  if (error) return <div className={styles.empty}>{t("netmap.changes.loadError")}</div>;
  if (!changes) return <div className={styles.empty}>…</div>;
  const w = changes.windows || {};
  const list = tab === "worsened" ? changes.worsened : changes.improved;
  return (
    <div>
      <div className={styles.sectionTitle}>{t("netmap.changes.title")}</div>
      <div className={styles.sectionHelp}>
        {t("netmap.changes.help", { recent: w.recent_days, baseline: w.baseline_days, drop: w.drop_points })}
      </div>
      <div className={styles.changeTabs}>
        <button type="button" className={`${styles.chip} ${tab === "worsened" ? styles.chipActive : ""}`} onClick={() => setTab("worsened")}>
          {t("netmap.changes.worsened")} <span className={styles.chipCount}>{changes.worsened.length}</span>
        </button>
        <button type="button" className={`${styles.chip} ${tab === "improved" ? styles.chipActive : ""}`} onClick={() => setTab("improved")}>
          {t("netmap.changes.improved")} <span className={styles.chipCount}>{changes.improved.length}</span>
        </button>
      </div>
      {changes.dead_zones.length > 0 && tab === "worsened" && (
        <div className={`${styles.status} ${styles.statusError}`}>
          {t("netmap.changes.deadZones")}: {changes.dead_zones.length}
        </div>
      )}
      {list.length === 0 ? (
        <div className={styles.empty}>{t("netmap.changes.none")}</div>
      ) : (
        <div className={styles.changeList}>
          {list.map((item) => <ChangeRow key={item.key} item={item} onGo={onGo} t={t} />)}
        </div>
      )}
    </div>
  );
}
